var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// Utils
import { performFetch } from './performFetch';
import { isError, isAbortError } from '../../errors';
import { FetchActions } from '../types/FetchActions';
import { FetchStates } from '../types/FetchStates';
/**
 * @description Retrieves the state transitions for the fetch state machine.
 *
 * @param {CreateFetchStateMachineProps} props - The properties for creating the fetch state machine.
 * @returns {StateTransitions<FetchStates, FetchActions, FetchContext>} The state transitions
 * for the fetch state machine.
 */
export var getFetchStateTransitions = function (_a) {
    var _b, _c, _d;
    var onSuccess = _a.onSuccess, onFailure = _a.onFailure, onAbort = _a.onAbort;
    var handleFetchAction = function (_a) {
        var performAction = _a.performAction, setContext = _a.setContext, _b = _a.payload, _c = _b.method, method = _c === void 0 ? 'GET' : _c, _d = _b.url, url = _d === void 0 ? '' : _d, body = _b.body, _e = _b.headers, headers = _e === void 0 ? new Headers() : _e, _f = _b.isDataResolvable, isDataResolvable = _f === void 0 ? function () { return true; } : _f;
        return __awaiter(void 0, void 0, void 0, function () {
            var abortController_1, error_1;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _g.trys.push([0, 2, , 3]);
                        abortController_1 = new AbortController();
                        setContext(function (prevContext) { return (__assign(__assign({}, prevContext), { abortController: abortController_1 })); });
                        return [4 /*yield*/, performFetch({
                                method: method,
                                url: url,
                                body: body,
                                headers: headers,
                                abortSignal: abortController_1.signal,
                                isDataResolvable: isDataResolvable,
                                onResolve: function (data) {
                                    performAction({ action: FetchActions.RESOLVE, payload: { resolvedData: data } });
                                },
                                onReject: function (error, additionalData) {
                                    performAction({ action: FetchActions.REJECT, payload: { rejectedData: error, additionalData: additionalData } });
                                },
                            })];
                    case 1:
                        _g.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _g.sent();
                        if (isError(error_1) && !isAbortError(error_1)) {
                            performAction({ action: FetchActions.REJECT, payload: { rejectedData: error_1 } });
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return _b = {},
        _b[FetchStates.IDLE] = (_c = {},
            _c[FetchActions.FETCH] = {
                toState: FetchStates.LOADING,
                actionHandler: handleFetchAction,
            },
            _c),
        _b[FetchStates.LOADING] = (_d = {},
            _d[FetchActions.RESOLVE] = {
                toState: FetchStates.SUCCESS,
                actionHandler: function (_a) {
                    var resolvedData = _a.payload.resolvedData;
                    return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_b) {
                            if (resolvedData) {
                                onSuccess(resolvedData);
                            }
                            return [2 /*return*/];
                        });
                    });
                },
            },
            _d[FetchActions.REJECT] = {
                toState: FetchStates.FAILURE,
                actionHandler: function (_a) {
                    var _b = _a.payload, rejectedData = _b.rejectedData, additionalData = _b.additionalData;
                    return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_c) {
                            if (rejectedData) {
                                onFailure(rejectedData, additionalData);
                            }
                            return [2 /*return*/];
                        });
                    });
                },
            },
            _d[FetchActions.ABORT] = {
                toState: FetchStates.IDLE,
                actionHandler: function (_a) {
                    var abortController = _a.context.abortController;
                    return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_b) {
                            abortController === null || abortController === void 0 ? void 0 : abortController.abort();
                            onAbort === null || onAbort === void 0 ? void 0 : onAbort();
                            return [2 /*return*/];
                        });
                    });
                },
            },
            _d),
        _b[FetchStates.SUCCESS] = {},
        _b[FetchStates.FAILURE] = {},
        _b;
};
//# sourceMappingURL=getFetchStateTransitions.js.map